// plop-templates/Component.tsx.hbs
import React from 'react';
import styles from './Layout.module.css';
import Header from '../components/Header/Header';
import AppRouter from '../router/router';
import { BrowserRouter } from 'react-router-dom';
import NavigationLoader from '../components/NavigationLoader/NavigationLoader';
import CustomerSupportWidget from '../components/CustomerSupportWidget/CustomerSupportWidget';

type Props = {};

const Layout: React.FC<Props> = () => {
  return (
    <BrowserRouter>
      <div>
        <Header />
        <NavigationLoader />
        <main className={styles.main}>
          <AppRouter />
        </main>
        <CustomerSupportWidget />
        <footer />
      </div>
    </BrowserRouter>
  );
};

export default Layout;
